import { render, staticRenderFns } from "./PSUItemCategory.vue?vue&type=template&id=cc079c9c&scoped=true&"
import script from "./PSUItemCategory.vue?vue&type=script&lang=js&"
export * from "./PSUItemCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc079c9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
